import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { lessonPrices, siteContent } from '../content/siteContent'
import type { ServiceId } from '../types'

type SubmitState = 'idle' | 'submitting' | 'success' | 'error'

export function ContactForm({ service }: { service: ServiceId }) {
  const [status, setStatus] = useState<SubmitState>('idle')
  const isWedding = service === 'wedding'

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    const form = event.currentTarget
    if (!form.checkValidity()) {
      form.reportValidity()
      return
    }
    setStatus('submitting')
    try {
      const response = await fetch(siteContent.formspreeEndpoint, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      })
      if (!response.ok) throw new Error('Form submission failed')
      form.reset()
      setStatus('success')
    } catch {
      setStatus('error')
    }
  }

  return (
    <form className="contact-form" onSubmit={handleSubmit} noValidate>
      <input type="hidden" name="service" value={isWedding ? 'Oprawa wokalna ślubu' : 'Lekcje śpiewu'} />
      <div className="honeypot" aria-hidden="true"><label>Nie wypełniaj tego pola<input name="_gotcha" tabIndex={-1} autoComplete="off" /></label></div>
      <div className="form-grid">
        <label>{isWedding ? 'Imię i nazwisko' : 'Imię'}<input name="name" autoComplete={isWedding ? 'name' : 'given-name'} required /></label>
        <label>Adres e-mail<input name="email" type="email" autoComplete="email" required /></label>
        {isWedding ? (
          <label className="form-grid__wide">Data i miejsce uroczystości<input name="data" placeholder="np. 14 czerwca 2027, Rzeszów" /></label>
        ) : (
          <label className="form-grid__wide">Rodzaj lekcji<select name="lesson" defaultValue="" required><option value="" disabled>Wybierz opcję</option>{lessonPrices.map((lesson) => <option key={lesson.title} value={lesson.title}>{lesson.title}</option>)}<option value="Lekcja stacjonarna w Rzeszowie">Lekcja stacjonarna w Rzeszowie</option></select></label>
        )}
        <label className="form-grid__wide">Wiadomość<textarea name="message" rows={6} required placeholder={isWedding ? 'Podaj datę uroczystości oraz miejscowość z kodem pocztowym' : 'Opowiedz krótko o swoim doświadczeniu i oczekiwaniach.'} /></label>
      </div>
      <p className="form-privacy">Wysyłając formularz, akceptujesz przetwarzanie danych w celu odpowiedzi na wiadomość. <Link to="/polityka-prywatnosci">Dowiedz się więcej</Link>.</p>
      <button className="button" type="submit" disabled={status === 'submitting'}>{status === 'submitting' ? 'Wysyłanie…' : 'Wyślij wiadomość'}</button>
      <div className="form-status" role="status" aria-live="polite">
        {status === 'success' && <p className="form-status--success">Dziękuję! Wiadomość została wysłana. Odpowiem tak szybko, jak to możliwe.</p>}
        {status === 'error' && <p className="form-status--error">Nie udało się wysłać wiadomości. Spróbuj ponownie lub napisz na <a href={`mailto:${siteContent.email}`}>{siteContent.email}</a>.</p>}
      </div>
    </form>
  )
}
